import TtamPromotionPixelList from './pixel-list/index.vue';
import TtamPromotionPixelIsEnable from './pixel-is-enable/index.vue';
import TtamPromotionPixelIosTips from './pixel-ios-tips/index.vue';
import TtamPromotionPixelConversionTips from './pixel-conversion-tips/index.vue';
import TtamPromotionPixelWebsiteType from './pixel-website-type/index.vue';
import TtamPromotionPixelMidFunnelTips from './pixel-mid-funnel-tips/index.vue';
import TtamPromotionPixelEventInactiveTips from './pixel-event-inactive-tips/index.vue';
import TtamPromotionPixelNativeTips from './pixel-native-tips/index.vue';

import * as hooks from './hooks';

export default {
  TtamPromotionPixelList,
  TtamPromotionPixelIosTips,
  TtamPromotionPixelIsEnable,
  TtamPromotionPixelConversionTips,
  TtamPromotionPixelWebsiteType,
  TtamPromotionPixelMidFunnelTips,
  TtamPromotionPixelEventInactiveTips,
  TtamPromotionPixelNativeTips,
  ...hooks,
};
